export const language: any = {
  OkLogout: "是",
  CloseLogout: "否",
  OkLeave: "退出",
  CloseLeave: "取消",
  LabelPolicy: "隐私政策",
  AppName: "Hey! Cooker",
  OnOffNotification: "通知开关",
  LabelReceiveNotificationSuggestion: "接收食谱推荐通知",
  LabelReceiveNotifyBreakfast: "接收每日早餐推荐",
  LabelReceiveNotifyLunch: "接收每日午餐推荐",
  LabelReceiveNotifyDinner: "接收每日晚餐推荐",
  notification_history: "通知历史",
  readAll: "全部已读",
  no_notification: "无通知历史",
  labelDisplayName: "输入显示名称",
  placeholderDisplayName: "请输入至少4个字符，最多20个字符",
  changeDisplayName: "更改显示名称",
};
